import { useState } from 'react'
import OtpInput from 'react-otp-input';

type Props = {
    otp: any,
    setOtp: any,
    handleMethod: any
}

const OTPContainer = (props: Props) => {

    const { otp, setOtp, handleMethod } = props

    const handleChange = (code: any) => {
        setOtp(code);
    }

    const handleClickSubmit = (e: any) => {

        if (e.key === "Enter" && otp?.length == 6) {
            e.preventDefault();
            handleMethod();

        } else {
            console.log("out");
        }
    }

    return (
        <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            inputType='number'
            // renderSeparator={<span>-</span>}
            renderInput={(props) => (
                <input {...props} onKeyDown={handleClickSubmit} />
            )}
            inputStyle={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                fontSize: "20px",
                margin: "5px",
                outlineColor: "#3366D6"
            }}
            shouldAutoFocus
        />
    );
}

export default OTPContainer